<template>
  <div class="role-page page-padding-top">
    <top-bar :title="i18n.t('share.title2')" parentId=".notice-page" @back="back"></top-bar>

    <div class="list black" >
      <div class="content">
        <div class="detail">{{$t('share.role1')}}</div>
        <div class="detail">{{$t('share.role2')}}</div>
        <div class="detail">{{$t('share.role3')}}</div>

        <div class="detail ">{{$t('share.role4')}}</div>
        <div class="detail">{{$t('share.role5')}}</div>
        <div class="detail">{{$t('share.role6')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getNoticeList } from '@/api/index'
import topBar from '@/components/topBar'
export default {
  components: {
    topBar
  },
  data() {
    return {
      
    }
  },
  mounted() {
  },
  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}
</script>